import {Body, Box, Subtitle1} from '@dagster-io/ui-components';

import AnimatedCheck from '@/components/AnimatedCheck';

export default function EmailSentConfirmation({description}: {description: string}) {
  return (
    <Box flex={{direction: 'column', gap: 12, alignItems: 'center'}}>
      <Box margin={{bottom: 24}} style={{width: '80px', height: '80px'}}>
        <AnimatedCheck />
      </Box>
      <Subtitle1>Check your inbox.</Subtitle1>
      <Body>{description}</Body>
    </Box>
  );
}
